import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { folderTypes } from "@redotech/redo-views-common/folders";
import { ReturnView } from "@redotech/redo-views-common/views";
import { ReactNode, createContext, memo } from "react";
import { useRecordViews } from "../../return/views/record-views-query";

export const ReturnViewsContext = createContext<
  | {
      teamViews?: ReturnView[];
      folders?: folderTypes["returns"][];
      reloadViews?: () => Promise<void>;
    }
  | undefined
>(undefined);

export const ReloadReturnViewsContext = createContext<
  (() => Promise<void>) | undefined
>(undefined);

export const ReturnViewsProvider = memo(function ReturnViewsProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const { views, folders, reloadViews } = useRecordViews(
    ReturnTypeEnum.RETURN,
    ReturnsAndClaimsPermissions.VIEW_RETURN,
  );

  return (
    <ReturnViewsContext.Provider
      value={{ teamViews: views, folders, reloadViews }}
    >
      <ReloadReturnViewsContext.Provider value={reloadViews}>
        {children}
      </ReloadReturnViewsContext.Provider>
    </ReturnViewsContext.Provider>
  );
});
